/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedCommodityCodesRouteImport } from './routes/_authenticated/commodity-codes'
import { Route as AuthenticatedDirectoryRouteImport } from './routes/_authenticated/directory'
import { Route as AuthenticatedBolsIndexRouteImport } from './routes/_authenticated/bols/index'
import { Route as AuthenticatedBolsBolIdRouteImport } from './routes/_authenticated/bols/$bolId'
import { Route as AuthenticatedHbolIndexRouteImport } from './routes/_authenticated/hbol/index'
import { Route as AuthenticatedHbolJobIdRouteImport } from './routes/_authenticated/hbol/$jobId'
import { Route as AuthenticatedSettingsCompanyRouteImport } from './routes/_authenticated/settings/company'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCommodityCodesRoute =
  AuthenticatedCommodityCodesRouteImport.update({
    id: '/commodity-codes',
    path: '/commodity-codes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDirectoryRoute = AuthenticatedDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBolsIndexRoute = AuthenticatedBolsIndexRouteImport.update({
  id: '/bols/',
  path: '/bols/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBolsBolIdRoute = AuthenticatedBolsBolIdRouteImport.update({
  id: '/bols/$bolId',
  path: '/bols/$bolId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHbolIndexRoute = AuthenticatedHbolIndexRouteImport.update({
  id: '/hbol/',
  path: '/hbol/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHbolJobIdRoute = AuthenticatedHbolJobIdRouteImport.update({
  id: '/hbol/$jobId',
  path: '/hbol/$jobId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsCompanyRoute =
  AuthenticatedSettingsCompanyRouteImport.update({
    id: '/settings/company',
    path: '/settings/company',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/commodity-codes': typeof AuthenticatedCommodityCodesRoute
  '/directory': typeof AuthenticatedDirectoryRoute
  '/bols/$bolId': typeof AuthenticatedBolsBolIdRoute
  '/hbol/$jobId': typeof AuthenticatedHbolJobIdRoute
  '/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/bols/': typeof AuthenticatedBolsIndexRoute
  '/hbol/': typeof AuthenticatedHbolIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/commodity-codes': typeof AuthenticatedCommodityCodesRoute
  '/directory': typeof AuthenticatedDirectoryRoute
  '/': typeof AuthenticatedIndexRoute
  '/bols/$bolId': typeof AuthenticatedBolsBolIdRoute
  '/hbol/$jobId': typeof AuthenticatedHbolJobIdRoute
  '/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/bols': typeof AuthenticatedBolsIndexRoute
  '/hbol': typeof AuthenticatedHbolIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/commodity-codes': typeof AuthenticatedCommodityCodesRoute
  '/_authenticated/directory': typeof AuthenticatedDirectoryRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/bols/$bolId': typeof AuthenticatedBolsBolIdRoute
  '/_authenticated/hbol/$jobId': typeof AuthenticatedHbolJobIdRoute
  '/_authenticated/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/_authenticated/bols/': typeof AuthenticatedBolsIndexRoute
  '/_authenticated/hbol/': typeof AuthenticatedHbolIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/account'
    | '/commodity-codes'
    | '/directory'
    | '/bols/$bolId'
    | '/hbol/$jobId'
    | '/settings/company'
    | '/bols/'
    | '/hbol/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/account'
    | '/commodity-codes'
    | '/directory'
    | '/'
    | '/bols/$bolId'
    | '/hbol/$jobId'
    | '/settings/company'
    | '/bols'
    | '/hbol'
    | '/users'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/account'
    | '/_authenticated/commodity-codes'
    | '/_authenticated/directory'
    | '/_authenticated/'
    | '/_authenticated/bols/$bolId'
    | '/_authenticated/hbol/$jobId'
    | '/_authenticated/settings/company'
    | '/_authenticated/bols/'
    | '/_authenticated/hbol/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/commodity-codes': {
      id: '/_authenticated/commodity-codes'
      path: '/commodity-codes'
      fullPath: '/commodity-codes'
      preLoaderRoute: typeof AuthenticatedCommodityCodesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/directory': {
      id: '/_authenticated/directory'
      path: '/directory'
      fullPath: '/directory'
      preLoaderRoute: typeof AuthenticatedDirectoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bols/': {
      id: '/_authenticated/bols/'
      path: '/bols'
      fullPath: '/bols/'
      preLoaderRoute: typeof AuthenticatedBolsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bols/$bolId': {
      id: '/_authenticated/bols/$bolId'
      path: '/bols/$bolId'
      fullPath: '/bols/$bolId'
      preLoaderRoute: typeof AuthenticatedBolsBolIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hbol/': {
      id: '/_authenticated/hbol/'
      path: '/hbol'
      fullPath: '/hbol/'
      preLoaderRoute: typeof AuthenticatedHbolIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hbol/$jobId': {
      id: '/_authenticated/hbol/$jobId'
      path: '/hbol/$jobId'
      fullPath: '/hbol/$jobId'
      preLoaderRoute: typeof AuthenticatedHbolJobIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/company': {
      id: '/_authenticated/settings/company'
      path: '/settings/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AuthenticatedSettingsCompanyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedCommodityCodesRoute: typeof AuthenticatedCommodityCodesRoute
  AuthenticatedDirectoryRoute: typeof AuthenticatedDirectoryRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedBolsBolIdRoute: typeof AuthenticatedBolsBolIdRoute
  AuthenticatedHbolJobIdRoute: typeof AuthenticatedHbolJobIdRoute
  AuthenticatedSettingsCompanyRoute: typeof AuthenticatedSettingsCompanyRoute
  AuthenticatedBolsIndexRoute: typeof AuthenticatedBolsIndexRoute
  AuthenticatedHbolIndexRoute: typeof AuthenticatedHbolIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedCommodityCodesRoute: AuthenticatedCommodityCodesRoute,
  AuthenticatedDirectoryRoute: AuthenticatedDirectoryRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedBolsBolIdRoute: AuthenticatedBolsBolIdRoute,
  AuthenticatedHbolJobIdRoute: AuthenticatedHbolJobIdRoute,
  AuthenticatedSettingsCompanyRoute: AuthenticatedSettingsCompanyRoute,
  AuthenticatedBolsIndexRoute: AuthenticatedBolsIndexRoute,
  AuthenticatedHbolIndexRoute: AuthenticatedHbolIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
